import React, { useEffect } from 'react';
import DefaultLayout from '~/pages/_layouts/full';
import Box from '~/components/Box';
import PageTitle from '~/components/PageTitle';
import { useTranslation } from 'react-i18next';
import { Breadcrumb } from 'antd';
import { BreadcrumbCustom } from '~/styles/global';

export default function Selections() {
  const { t } = useTranslation();

  useEffect(() => {
    
  }, []);

  const breadcrumb = 
    <BreadcrumbCustom>
      <Breadcrumb.Item href="/">{t('menus:home')}</Breadcrumb.Item>
      <Breadcrumb.Item>{t('menus:projects')}</Breadcrumb.Item>
      <Breadcrumb.Item>{t('menus:selections')}</Breadcrumb.Item>
    </BreadcrumbCustom>
  ;

  return (
    <DefaultLayout breadcrumb={breadcrumb}>
      <Box>
        <PageTitle title={t('menus:selections')} />
      </Box>
    </DefaultLayout>
  );
}
